module.exports = __webpack_public_path__ + "images/bck-search-mobile.png?a7bd54ad7d05d96bb62db10663aa3d76";